import { render, staticRenderFns } from "./pendingIncident.vue?vue&type=template&id=207c6f24&scoped=true"
import script from "./pendingIncident.vue?vue&type=script&lang=js"
export * from "./pendingIncident.vue?vue&type=script&lang=js"
import style0 from "./pendingIncident.vue?vue&type=style&index=0&id=207c6f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c6f24",
  null
  
)

export default component.exports